<template>
  <div>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          이메일주소 <span class="asterisk">*</span>
        </v-list-item-title>
        <v-text-field
          solo
          required
          ref="refEmail"
          placeholder="이메일주소"
          :height="formHeight"
          :rules="[emailRules.required, emailRules.counter, emailRules.email]"
          v-model="userData.email"
          append-icon="mdi-check" />
      </v-list-item-content>
    </v-list-item>
    <v-list-item  v-if="!isAuthorized">
      <v-list-item-content>
        <v-list-item-title>
          담당자명
        </v-list-item-title>
        <v-text-field
          solo
          required
          ref="refManager"
          placeholder="담당자명"
          :height="formHeight"
          :rules="userData.manager?[lessCounterRuleByLength(10)]:[]"
          v-model="userData.manager"
          append-icon="mdi-check" />
      </v-list-item-content>
    </v-list-item>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Cookies from "js-cookie";
const rulesService = require("@/utils/rules.js");
import { lessCounterRuleByLength } from "@/utils/rules.js";

export default {
  props: {
    userData: {
      type: Object,
    },
  },
  computed: {
    accessInfo() {
      if (!this.isAuthorized) return;
      const CookieName = process.env.VUE_APP_CookieName;
      return JSON.parse(Cookies.get(CookieName));
    },
    ...mapGetters(["isAuthorized", "getThemeMode"]),
  },
  data() {
    return {
      formHeight: 52,
      emailRules: rulesService.emailRules(),
      lessCounterRuleByLength,
   };
  },
};
</script>
<style lang="">
</style>
